const prepend = ({ data, loadingState, oldData, draft }) => {
  const result = { ...oldData, loading: false };

  if (Array.isArray(oldData?.items)) {
    result.items = [data, ...oldData.items];
    result.totalItems = (oldData.totalItems || 0) + 1;
  }

  if (Array.isArray(oldData?.data)) {
    result.data = [data, ...oldData.data];
    result.totalItems = (oldData.totalItems || 0) + 1;
  }

  if (!draft?.items && !draft?.data && Array.isArray(oldData)) {
    return [data, ...oldData];
  }

  return result;
};

export default prepend;
